import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// @ts-ignore
import VCalendar from 'v-calendar'
import App from './App.vue'
import router from './router'
import store from './store'
import TrelloClient from './TrelloClient'
import '@/assets/custom.scss'

Object.defineProperty(Vue.prototype, 'trello', { value: new TrelloClient() })
Vue.use(BootstrapVue)
Vue.use(VCalendar, {
    firstDayOfWeek: 2, // Monday
    locale: 'it-it',
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
